import {Box, Grid, Typography} from '@mui/material';
import {useState} from 'react';
import {NavLink} from 'react-router-dom';
import map2 from '../../assets/map-2.png';
import loc from '../../assets/loc-1.png';

const RightRes = () => {
  const [showM, setShowM] = useState(false);

  const handleHideShowM = () => {
    setShowM(false);
  };
  const handleShowM = () => {
    setShowM(true);
  };
  return (
    <div>
      <NavLink
        onMouseOver={handleShowM}
        onMouseLeave={handleHideShowM}
        to='http://google.com'
        style={{
          textDecoration: showM ? 'none' : 'none',
          backdropFilter: showM ? 'blur(3px)' : 'none',
        }}>
        <Box sx={{display: 'flex', paddingTop: '0%'}}>
          <Grid lg={6}>
            <Box sx={{paddingLeft: {md: '40%', sm: '40%', xs: '40%'}, marginTop: '0%'}}>
              <Typography variant='h4' sx={{color: '#e7c978'}}>
                Newtown,VA
              </Typography>
              {showM ? (
                <>
                  <Typography variant='h6' sx={{color: '#fff'}}>
                    Push Show Me
                  </Typography>
                </>
              ) : (
                <>
                  <Typography variant='h6' sx={{color: '#fff'}}>
                    Show Me Direction
                  </Typography>
                </>
              )}
            </Box>
            <Box
              component='img'
              src={loc}
              sx={{
                width: {xl: '100%', lg: '120%', md: '100%', sm: '100%', xs: '100%'},
                marginLeft: '150px',
                zIndex: 10,
                position: 'relative',
                marginTop: '-15%',
              }}
            />
          </Grid>
          <Grid lg={6}>
            <Box
              component='img'
              src={map2}
              sx={{
                width: {
                  xl: '100%',
                  lg: '110%',
                  md: '100%',
                  sm: '100%',
                  xs: '100%',
                  marginTop: '50px',
                  zIndex: 5,
                },
              }}
            />
          </Grid>
        </Box>
      </NavLink>
    </div>
  );
};

export default RightRes;
